import axios from "axios";

export const listSatellite = (data) => axios("satinfo/satellites/", { params: data });
export const getSatellite = (data) => axios(`satinfo/satellites/${data.id}/`);
export const getSatelliteTLE = (data) => axios("satinfo/tles/", { params: data });
